const ITEMS = [
  "O REI DA 25",
  "O NOVO PADRÃO DE REVENDA",
  "LUXO ACESSÍVEL",
  "25 DE MARÇO",
  "EM BREVE NO DIGITAL",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="relative overflow-hidden border-y border-gold/15 bg-[#0A0A0A] py-6"
  >
    <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center gap-10">
          {ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center gap-10">
              <span
                className={`font-serif text-2xl sm:text-3xl ${
                  i % 2 === 0 ? "gold-text italic" : "text-neutral-600"
                }`}
              >
                {item}
              </span>
              <span className="text-lg text-royal">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
